/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type RiskyLoginConfirmMutationVariables = Types.Exact<{
  input: Types.RiskyLoginConfirmInput;
}>;
export type RiskyLoginConfirmMutation = {
  __typename?: "Mutation";
  riskyLoginConfirm?: {
    __typename?: "RiskyLoginConfirmPayload";
    result: {
      __typename?: "RiskyLoginConfirmError";
      code: Types.RiskyLoginConfirmErrorCode;
      message: string;
    } | {
      __typename?: "RiskyLoginConfirmSuccess";
      riskyLoginConfirmation: {
        __typename?: "RiskyLoginConfirmation";
        loginEventId: string;
        status: Types.RiskyLoginStatus;
      };
    };
  } | null;
};
export const RiskyLoginConfirmDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "RiskyLoginConfirm"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "RiskyLoginConfirmInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "riskyLoginConfirm"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "RiskyLoginConfirmSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "riskyLoginConfirmation"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "loginEventId"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "status"
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "RiskyLoginConfirmError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "code"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type RiskyLoginConfirmMutationFn = Apollo.MutationFunction<RiskyLoginConfirmMutation, RiskyLoginConfirmMutationVariables>;

/**
 * __useRiskyLoginConfirmMutation__
 *
 * To run a mutation, you first call `useRiskyLoginConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRiskyLoginConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [riskyLoginConfirmMutation, { data, loading, error }] = useRiskyLoginConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRiskyLoginConfirmMutation(baseOptions?: Apollo.MutationHookOptions<RiskyLoginConfirmMutation, RiskyLoginConfirmMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<RiskyLoginConfirmMutation, RiskyLoginConfirmMutationVariables>(RiskyLoginConfirmDocument, options);
}
export type RiskyLoginConfirmMutationHookResult = ReturnType<typeof useRiskyLoginConfirmMutation>;
export type RiskyLoginConfirmMutationResult = Apollo.MutationResult<RiskyLoginConfirmMutation>;
export type RiskyLoginConfirmMutationOptions = Apollo.BaseMutationOptions<RiskyLoginConfirmMutation, RiskyLoginConfirmMutationVariables>;